var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-video';
                    var viewUrl = 'sprite.svg#view-icon-video';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 42 30',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };